module.exports = __webpack_public_path__ + "static/polar-extraimg1@2x-min-c24e1c486e6ed3acb20bd165e1124d4b.png";